// extracted by mini-css-extract-plugin
export default {"emptyState":"r08Fq"};